import axios from "axios";
const backendUrl = process.env.NODE_ENV == 'development'? 'http://localhost:5000':process.env.REACT_APP_BACKEND_URL;
const API_URL=`${backendUrl}/api/v1/million`
const getTokenInfo= (tokenId,callback) => {

        const options = {
            url: `${API_URL}/getTokenInfo`,
            method: "POST",
            data:{tokenId:tokenId}
        };
        axios(options).then((resp) => {
            callback && callback(true,resp.data);
        }).catch(err=>{

            callback && callback(false,err);
        })

};
const tokenMinted= (info,callback) => {
    const options = {
        url: `${API_URL}/tokenMinted`,
        method: "POST",
        data:info
    };
    axios(options).then((resp) => {
        callback && callback(true,resp.data);
    }).catch(err=>{

        callback && callback(false,err?.response?.data);
    })

};
const uploadTokenMetadata= (info,callback) => {

    const options = {
        url: `${API_URL}/uploadTokenMetadata`,
        method: "POST",
        data:info
    };
    axios(options).then((resp) => {
        callback && callback(true,resp.data);
    }).catch(err=>{

        callback && callback(false,err?.response?.data);
    })

};
const updateTokenMetadata= (info,callback) => {

    const options = {
        url: `${API_URL}/updateTokenMetadata`,
        method: "POST",
        data:info
    };
    axios(options).then((resp) => {
        callback && callback(true,resp.data);
    }).catch(err=>{

        callback && callback(false,err?.response?.data);
    })

};
const mintedTokens= (callback) => {

    const options = {
        url: `${API_URL}/mintedTokens`,
        method: "GET"

    };
    axios(options).then((resp) => {
        callback && callback(true,resp.data);
    }).catch(err=>{
        callback && callback(false,err);
    })

};
const mintAvailable = (info,callback) => {

    const options = {
        url: `${API_URL}/mintAvailable`,
        method: "POST",
        data:info
    };
    axios(options).then((resp) => {
        callback && callback(true,resp.data);
    }).catch(err=>{
        callback && callback(false,err);
    })

};
const getTokensByOwner = (address,callback)=>{
    const options = {
        url: `${API_URL}/getTokensByOwner`,
        method: "POST",
        data: {address:address}
    };
    axios(options).then((resp) => {
        callback && callback(true,resp.data);
    }).catch(err=>{
        callback && callback(false,err?.response?.data);
    })
}
export {getTokenInfo,tokenMinted,mintedTokens,updateTokenMetadata,uploadTokenMetadata,mintAvailable,getTokensByOwner}
